import { Trans } from '@lingui/react/macro';

export const Colour = ({ color }) => {
  switch (color?.toLowerCase()) {
    case 'black':
      return <Trans>Black</Trans>;
    case 'charcoal':
      return <Trans>Charcoal</Trans>;
    case 'light blue':
      return <Trans>Light blue</Trans>;
    case 'navy':
      return <Trans>Navy</Trans>;
    case 'red':
      return <Trans>Red</Trans>;
    case 'royal blue':
      return <Trans>Royal blue</Trans>;
    case 'sports grey':
      return <Trans>Sports grey</Trans>;
    case 'white':
      return <Trans>White</Trans>;
    case 'green':
      return <Trans>Green</Trans>;
    case 'brown':
      return <Trans>Brown</Trans>;
    case 'sapphire heather':
      return <Trans>Sapphire heather</Trans>;
    case 'red heather':
      return <Trans>Red heather</Trans>;
    case 'dark heather':
      return <Trans>Dark heather</Trans>;
    case 'dark chocolate':
      return <Trans>Dark chocolate</Trans>;
    case 'kiwi':
      return <Trans>Kiwi</Trans>;
    case 'chestnut':
      return <Trans>Chestnut</Trans>;
    case 'random':
      return <Trans>Random</Trans>;
    case 'none':
      return;
    default:
      return color;
  }
};
